<template>
	<div class="page">
		<!-- your page -->
		<div class="title">
			<div class="fixation">
				<div class="home" @click="goIndex">
					<div class="icon"><img src="../assets/index/home.png" alt=""></div>
					<div class="word">首页</div>
				</div>
				<!-- <div class="province">
					<div class="icon"><img src="../assets/index/position.png" alt=""></div>
					<div class="word">河北省</div>
				</div> -->
				<div class="hello">
					{{time}}好，欢迎来到{{shop_name}}
				</div>
				<div class="log_reg" v-if="keyword!='login'">
					<div class="noLog" v-if="logStatus">
						<div class="Item" @click="goLogin">
							[请登录]
						</div>
						<div class="Item" @click="goRegister">
							[注册]
						</div>
					</div>
					<div class="inLog" v-if="!logStatus">
						<div class="username" @click="goPerson">
							[{{userinfo.nickname}}]
						</div>
						<div class="logOut" @click="logOut">
							[退出]
						</div>
					</div>
				</div>
				<div class="log_reg" v-if="keyword=='login'"></div>
				<div class="phone">
					联系电话:{{tel}}
				</div>
				<div class="webNav">
					<div class="icon">
						<img src="../assets/index/down.png" alt="">
					</div>
					<div class="word">
						网站导航
					</div>
				</div>
			</div>
		</div>
		<div class="logo">
			<div class="fixation">
				<div class="logoBox" @click="goIndex">
					<img :src="logo" alt="">
				</div>
				<div class="search">
					<div class="searchBox">
						<div class="searchInput">
							<input type="text" placeholder="请输入您要搜索的内容" v-model="search">
						</div>
						<div class="searchBtn">
							<button @click="goSearch">
								搜索
							</button>
						</div>
					</div>
					<div class="history">
						<div class="item" v-for="item in searchHistory" @click="useHistory" :data-name="item">{{item}}</div>
					</div>
				</div>
				<div class="buycar">
					<div class="buycarbtn" @click="goCart">
						<i class="el-icon-shopping-cart-2"></i>
						购物车
					</div>
				</div>
			</div>
		</div>
		<div class="nav">
			<div class="fixation">
				<div class="allType">
					<div class="icon">
						<img src="../assets/index/menu.png" alt="">
					</div>
					<div class="word">
						全部商品分类
					</div>
				</div>
				<div class="navBox">
					<div class="navIndex" @click="goIndex">
						首页
					</div>
					<div class="navItem" v-for="item in navList" :data-id="item.id" @click="selectNav">
						{{item.name}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'pubHead',
		data(){
			return {
				logStatus:true,
				time:"",
				navList:[
				],
				userinfo:{},
				keyword:'',
				search:'',
				tel:"",
				searchHistory:[],
				shop_name:"",
        logo:''
			}
		},
		methods:{
			useHistory(e){
				this.search = e.target.dataset.name
				this.goSearch()
			},
			getAllCat(){
				var data = {
					"method":"categories.getallcat"
				}
				var navList = this.navList
				var that = this
				this.request(data,(res)=>{
					if(res.status){
						var relist = res.data
						for (var i = 0; i < relist.length; i++) {
							var item = relist[i]
							var obj = {}
							if(i<6){
								obj['id'] = item.id
								obj['name'] = item.name
							}else if(i>=6){
								break
							}
							navList.push(obj)
						}
						// navList.push({'id':'001','name':'积分商城'})
						// navList.push({'id':'002','name':'企业采购定制信息'})
						that.navList = navList
					}else{
						that.globalTest('categories.getallcat','error',res.msg,res.data)
					}
				})
			},
			goPerson(){
				//去个人中心
				this.$router.push({path:"/person/info",query:{mid:8}})
			},
			goSearch(){
				//去搜索
				var search = this.search
				var url = window.location.href
				var searchHistory = JSON.parse(localStorage.getItem('searchHistory'))
				if(searchHistory!=undefined){
					var index
					for (let i in searchHistory) {
						if(search==searchHistory[i]){
							index=i
							break
						}
					}
					if(index==undefined){
						if(searchHistory.length<6){
							searchHistory.push(search)
						}else{
							searchHistory.splice(searchHistory.length-1,1)
							searchHistory.push(search)
						}
					}
					localStorage.setItem('searchHistory',JSON.stringify(searchHistory))
				}else{
					var arr = new Array()
					arr.push(search)
					localStorage.setItem('searchHistory',JSON.stringify(arr))
				}
				var route = url.split('?')[0].split('/')[url.split('/').length-1]
				this.$router.push({path:'/type',query:{search:search,type:'search'}})
				if(route=='type'){
					this.$router.go(0)
				}
			},
			logOut(){
				//退出登录
				var data = {
					"method":"user.logout",
					"token":this.token
				}
				var that = this
				this.$confirm('将要退出登录，是否确定？','提示',{
					confirmButtonText:"确定",
					cancelButtonText:'取消',
					type:'warning'
				}).then(()=>{
					that.request(data,function(res){
						if(res.status){
							localStorage.clear()
							that.globalTest('user.logOut','success','退出登录成功')
							that.$router.push({path:"/login",query:{type:1}})
						}else{
							localStorage.clear()
							that.globalTest('user.logOut','error',res.msg,res.data)
						}
					})
				}).catch(()=>{
					this.$message({
						type:'info',
						message:'您取消了操作'
					})
				})
			},
			getInfo(){
				//获取用户信息
				var that = this
				this.getUserInfo(function(res){
					that.userinfo = res
					localStorage.setItem('userInfo',JSON.stringify(res))
				})
			},
			goCart(){
				this.$router.push({path:"/cart",query:{}})
			},
			selectNav(e){
				var id = e.target.dataset.id
				if(id=="001"){
					this.$router.push({path:"/score",query:{}})
				}else if(id=="002"){

				}else{
					this.$router.push({path:"/type",query:{"catid":id,"type":"catid"}})
				}
				var url = window.location.href
				var route = url.split('?')[0].split('/')[url.split('/').length-1]
				if(route=='type'){
					this.$router.go(0)
				}
			},
			goIndex(){
				this.$router.push({path:'/',query:{}})
			},
			goLogin(){
				this.$router.push({path:"/login",query:{type:1}})
			},
			goRegister(){
				this.$router.push({path:"/login",query:{type:2}})
			},
			getTime(){
				var date = new Date()
				var time = date.getHours()
				if(time>=6&&time<8){
					this.time="早上"
				}else if(time>=8&&time<11){
					this.time="上午"
				}else if(time>=11&&time<13){
					this.time="中午"
				}else if(time>=13&&time<17){
					this.time="下午"
				}else if(time>=17&&time<22){
					this.time="晚上"
				}else if(time>=22&&time<24){
					this.time="深夜"
				}else if(time>=0&&time<6){
					this.time="凌晨"
				}
			},
			fetchCopyRight(){
				var data = {
					method:"config.config"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.tel = res.data.tel
						that.shop_name = res.data.shop_name
            that.logo = res.data.logo
					}else{
						that.globalTest('config.config','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.getTime()
			this.getAllCat()
			this.fetchCopyRight()
			var url = window.location.href.split('/#/')[1].split('?')[0]
			this.keyword = url
			this.token = localStorage.getItem('token')
			this.searchHistory = JSON.parse(localStorage.getItem('searchHistory'))
			if(this.token!=null){
				this.logStatus = false
				this.getInfo()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.page{
		background: #FFFFFF;
	}
	.title{
		width: 100%;
		height: 30px;
		background: #F0F0F0;
		line-height: 30px;
		font-size: 12px;
	}
	.home,.province,.hello,.log_reg,.phone,.webNav{
		height: 100%;
		width: 150px;
		float: left;
	}
	.home,.province,.webNav{
		cursor: pointer;
	}
	.home:hover{
		background: #E3E3E3;
	}
	.home,.province{
		width: 100px;
	}
	.icon{
		width: 12px;
		height: 12px;
		float: left;
		margin-top: 9px;
	}
	.icon img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.word{
		width: 70px;
		height: 100%;
		float: left;
		padding-left: 10px;
		box-sizing: border-box;
		padding-right: 10px;
	}
	.hello{
		width: 300px;
	}
	.log_reg{
		width: 250px;
	}
	.noLog{
		width: 150px;
		height: 100%;
	}
	.inLog{
		width: 100%;
		height: 100%;
	}
	.phone{
		width: 400px;
		text-align: right;
	}
	.webNav{
		text-align: right;
	}
	.log_reg .Item{
		width: 75px;
		height: 100%;
		float: left;
		cursor: pointer;
		color: #036DEE;
	}
	.log_reg .Item:hover{
		background: #E3E3E3;
	}
	.inLog .username{
		max-width: 175px;
		height: 100%;
		float: left;
		padding-right: 10px;
		box-sizing: border-box;
		cursor: pointer;
		color: #036DEE;
	}
	.inLog .logOut{
		width: 75px;
		height: 100%;
		float: left;
		cursor: pointer;
		color: #036DEE;
	}
	.webNav div{
		float: right;
	}
	.webNav .word{
		padding-left: 0px;
	}
	.logo{
		width: 100%;
		height: 90px;
	}
	.logoBox{
		width: 310px;
		height: 90px;
		float: left;
		cursor: pointer;
	}
	.logoBox img{
		height: 100%;
		display: block;
	}
	.search{
		width: 600px;
		height: 100%;
		float: left;
	}
	.searchBox{
		width: 450px;
		height: 36px;
		float: right;
		margin-top: 30px;
		border: 2px solid #036DEE;
		box-sizing: border-box;
	}
	.history{
		width: 450px;
		height: 20px;
		float: right;
		line-height: 20px;
	}
	.history .item{
		max-width: 90px;
		height: 100%;
		float: left;
		font-size: 12px;
		color: #838383;
		overflow: hidden;
	}
	.searchBox .searchInput{
		width: 348px;
		height: 100%;
		float: left;
	}
	.searchBox .searchInput input{
		width: 100%;
		height: 100%;
		display: block;
		border: none;
		background: #F9F9F9;
		font-size: 14px;
		padding-left: 32px;
		box-sizing: border-box;
		background: url('../assets/index/search.png') no-repeat;
		background-size: 16px 16px;
		background-position: 8px 8px;
	}
	.searchBtn{
		width: 98px;
		height: 100%;
		float: left;
	}
	.searchBtn button{
		width: 100%;
		height: 100%;
		background: -webkit-linear-gradient(left, #56a2ff , #036dee); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #56a2ff, #036dee); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #56a2ff, #036dee); /* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #56a2ff , #036dee); /* 标准的语法 */
		border: none;
		color: #FFFFFF;
		cursor: pointer;
	}
	.buycar{
		width: 290px;
		height: 100%;
		float: left;
	}
	.buycarbtn{
		width: 120px;
		height: 36px;
		float: right;
		margin-top: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		color: #036DEE;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
		cursor: pointer;

	}
	.buycarbtn i{
		font-size: 16px;
		margin-right: 5px;
	}
	.buycarbtn .icon{
		width: 18px;
		height: 18px;
		margin-left: 25px;
		margin-top: 7px;
	}
	.buycarbtn .word{
		width: 70px;
		height: 100%;
		float: left;
		text-align: center;
		line-height: 32px;
	}
	.nav{
		width: 100%;
		height: 40px;
		background: #197aff;
		color: #FFFFFF;
		line-height: 40px;
	}
	.allType{
		width: 200px;
		height: 100%;
		float: left;
		background: #1c73eb;
	}
	.allType .icon{
		width: 24px;
		height: 24px;
		float: left;
		margin-top: 8px;
		margin-left: 30px;
	}
	.allType .word{
		width: 140px;
		height: 100%;
		float: left;
		font-size: 14px;
	}
	.allType .icon img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.navBox{
		width: 1000px;
		height: 100%;
		float: left;
	}
	.navBox .navIndex{
		width: 90px;
		height: 100%;
		float: left;
		text-align: center;
		cursor: pointer;
		font-size: 14px;
	}
	.navBox .navIndex:hover{
		background: #0053b8;
	}
	.navBox .navItem{
		width: 125px;
		height: 100%;
		float: left;
		text-align: center;
		cursor: pointer;
		font-size: 14px;
	}
	.navBox .navItem:hover{
		background: #0053b8;
	}
</style>
